/* 
 * 电瓶低电压报警
 * 描述： 
 * 创建时间：2017-04-12 
 * 创建人：baixx 
 */
<template>
	<div id="faultAlarmPowerLow" class="wrapper wrapper-content animated fadeInRight tabBox">
		<div class="ibox-content">
			<!--头部导航模块-->
			<div class="row">
				<div class="col-sm-12">
					<div class="alarm_process_icon">
						<ul>
							<li :class="{ active: stepOneActive, 'finish': !stepOneActive && stepOneStatus }"><i class="icon iconfont icon-jibenxinxi"></i><span>基本信息</span></li>
							<li :class="{ active: stepTwoActive, 'finish': !stepTwoActive && stepTwoStatus }"><i class="icon iconfont icon-baojingfangshi"></i><span>报警方式</span></li>
							<li :class="{ active: stepThreeActive, 'finish': !stepThreeActive && stepThreeStatus }"><i class="icon iconfont icon-jiankongquyu"></i><span>报警频度</span></li>
							<li :class="{ active: stepFourActive, 'finish': !stepFourActive && stepFourStatus }"><i class="icon iconfont icon-jiankongcheliang"></i><span>监控车辆</span></li>
							<li :class="{ active: stepSixActive }"><i class="icon iconfont icon-wancheng"></i><span>完成</span></li>
						</ul>
					</div>
				</div>
			</div>
			<!--step-1:基本信息模块-->
			<div :style="{ display: stepOneActive?'block':'none' }">
				<AlarmPlanBase v-model="alarmBaseInfo" :imageData="imgdata" title="电瓶低电压报警" systemAlarms="当车辆进入特定的电子围栏区域时，触发系统报警。" bgClass="alarm_list_bg09"></AlarmPlanBase>
			</div>
			<!--step-2:报警方式模块-->
			<div :style="{ display: stepTwoActive?'block':'none' }">
				<AlarmPlanMode v-model="alarmModeInfo" :parentid="pageid"></AlarmPlanMode>
			</div>
			<!--step-3:报警频度-->
			<div :style="{ display: stepThreeActive?'block':'none' }">
				<!--报警频度部分-->
				<div class="row">
					<form role="form" class="form-inline grey_box ofh pt10px">
						<div class="col-sm-11 col-sm-offset-1">
							<div class="form-group pt5px">
								<label style="padding-top:3px;" class="focus_color">报警频度</label>
							</div>
							<div class="form-group pl15px">
								<span>每</span>
							</div>
                            <div class="form-group">
                            	<input-number v-model="alarmPowerLow.alarmMinuteCount" :min="1" :max="9999" :controls="false" :inputWidth="90"></input-number>
                            </div>
                            <div class="form-group mr30px">
								<span>分钟发送</span>
							</div>
							<div class="form-group pt5px mr30px">
                                <label>
                                	<radio v-model="alarmPowerLow.alarmLimitMode" true-value="limit">不限</radio>
            					</label>
                            </div>
                            <div class="form-group pt5px mr30px">
                                <label>
                                	<radio v-model="alarmPowerLow.alarmLimitMode" true-value="nolimit">限制为</radio>
            					</label>
                            </div>
                            <input-number v-model="alarmPowerLow.alarmLimitNum" :min="1" :max="99" :controls="false" :inputWidth="90" :disabled="alarmPowerLowStatus"></input-number>
                            <div class="form-group">
								<span>次报警</span>
							</div>
						</div>
					</form>
				</div>
			</div>
			<!--step-4:监控车辆模块-->
			<div :style="{ display: stepFourActive?'block':'none' }">
				<AlarmPlanMonitor v-model="alarmMonitorInfo" :typeid="typeid"></AlarmPlanMonitor>
			</div>
			<!--step-5:完成-->
			<div :style="{ display: stepSixActive?'block':'none' }">
			</div>
			<!--页脚控制部分-->
			<div class="row">
				<div class="col-sm-12 text-center pt10px">
					<button type="button" class="btn btn-primary " v-if="preBtnStatus" @click="preStep">上一步</button>
					<button type="button" class="btn btn-primary " v-if="nextBtnStatus" @click="nextStep">下一步</button>
					<button type="button" class="btn btn-primary " v-if="finishBtnStatus">完成</button>
				</div>
			</div>
			<!--弹出框子组件-->
			<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
				{{messageStr}}
				<div slot="footer">
			        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
			    </div>
			</tab-modal>
		</div>
	</div>
</template>

<script>
	import Pagination from 'components/common/Pagination'
	import {ALARM_ICON_POWERLOW} from 'static/constant'
	import InputNumber from 'components/common/InputNumber'
	import Radio from 'components/common/Radio'
	import Checkbox from 'components/common/Checkbox'
	import TabModal from 'components/common/TabModal'
	import AlarmPlanBase from 'components/pages/vehiclealarm/common/AlarmPlanBase'
	import AlarmPlanMode from 'components/pages/vehiclealarm/common/AlarmPlanMode'
	import AlarmPlanMonitor from 'components/pages/vehiclealarm/common/AlarmPlanMonitor'
	import { OPERATE_EXCEPTION} from 'static/message'
	import classlist from 'util/classlist'
	import {isPhone} from 'util/util'
	
	export default {
		name: 'PageFaultAlarmPowerLow',
		components: {
			Pagination,
			InputNumber,
			Radio,
			Checkbox,
			TabModal,
			AlarmPlanBase,
			AlarmPlanMode,
			AlarmPlanMonitor
		},
		// 接收参数
		created(){
			this.mode = this.$route.query.mode;
			this.planid = this.$route.query.planid;
		},
		data() {
			return {
				pageid:'faultAlarmPowerLow',
				typeid:'14',
				imgdata:ALARM_ICON_POWERLOW,
				stepIndex:1,                      //当前步骤索引
				stepMaxIndex:1,					  //最大步骤索引
				stepOneStatus:false,              //基本信息完成状态
				stepTwoStatus:false,              //报警方式完成状态
				stepThreeStatus:false,             //报警频度完成状态
				stepFourStatus:false,             //监控车辆完成状态
				//基本信息
				alarmBaseInfo: {
				},
				//报警方式
				alarmModeInfo: {
				},
				//报警频度
				alarmPowerLow: {
					alarmLimitMode: "limit",	  //报警频度
					alarmMinuteCount: "5",        //分钟数
					alarmLimitNum:"2"              //报警次数
				},
				//监控车辆
				alarmMonitorInfo: {
				},
				messageStr: "",				      // 弹出框内容
				scrollTop: '0'
			};
		},
		watch: {
        },
		computed: {
			//基本信息激活状态
			stepOneActive: function () {
		        return this.stepIndex===1;
		    },
		    //报警方式激活状态
		    stepTwoActive: function () {
		        return this.stepIndex===2;
		    },
		      //报警频度激活状态
		    stepThreeActive: function () {
		        return this.stepIndex===3;
		    },
		    //监控车辆激活状态
		    stepFourActive: function () {
		        return this.stepIndex===4;
		    },
		    //完成激活状态
		    stepSixActive: function () {
		        return this.stepIndex===5;
		    },
		    //上一步按钮是否显示
		    preBtnStatus: function () {
		        return this.stepIndex!==1;
		    },
		    //下一步按钮是否显示
		    nextBtnStatus: function () {
		        return this.stepIndex!==5;
		    },
		    //完成按钮是否显示
		    finishBtnStatus: function () {
		        return this.stepIndex===5;
		    },
		     //限制次数输入框状态(第三步)
		    alarmPowerLowStatus: function () {
		    	return this.alarmPowerLow.alarmLimitMode==='limit';
		    },
		},
		methods:{
			//下一步事件
			nextStep() {
				this.stepIndex += 1;
				if (this.stepIndex > this.stepMaxIndex){
					this.stepMaxIndex = this.stepIndex;
				}
				this.stepOneStatus = this.stepMaxIndex >= 1;
				this.stepTwoStatus = this.stepMaxIndex > 2;
				this.stepThreeStatus = this.stepMaxIndex > 3;
				this.stepFourStatus = this.stepMaxIndex > 4;
			},
			//上一步事件
			preStep() {
				if (this.stepIndex===1){
					return;
				}
				this.stepIndex -= 1;
			},
			// 消息弹出框相关 
			openModal(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#faultAlarmPowerLow',this);
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		classlist.toggleScroll('open','#faultAlarmPowerLow',this);
        	},
        	closeModalMsg(){
        		this.closeModal("modalMsg");
        	},
        	openModalMsg(message){
        		this.messageStr = message;
        		this.openModal("modalMsg")
        	},
		}
	}
</script>

<style scoped>
	@import '../../../../assets/project/css/iconfont/iconfont.css';
     .grey_box label{
    	font-weight: normal;
    }
</style>



// WEBPACK FOOTER //
// PageFaultAlarmPowerLow.vue?250f0770